import * as React from 'react';

import { AttributeTableItem } from 'src/containers/ProjectDiagram/components/attributesTable/types';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { addAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/addAttribute';
import { addDomainToAttributeModelData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/addDomainToAttributeModelData';
import { removeDomainFromAttributeModelData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/removeDomainFromAttributeModelData';

export const useRemoveAttributeFromClass = (classIri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (item: AttributeTableItem) => {
      if (!diagram || !classIri) {
        return;
      }
      commitDiagramModel(
        diagram,
        removeDomainFromAttributeModelData({
          domain: classIri,
          value: item.value,
        })
      );
    },
    [classIri, diagram]
  );
};

export const addAttributeItemToClass =
  (classIri: string, item: AttributeTableItem) => (model: Model) => {
    if (item.isNewlyCreated) {
      addAttribute(item)(model);
    }

    addDomainToAttributeModelData({ value: item.value, domain: classIri })(
      model
    );
  };

export const useAddAttributeToClass = (classIri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (item: AttributeTableItem) => {
      if (!item || !diagram || !classIri) {
        return;
      }

      if (item.isNewlyCreated && !item.text) {
        return;
      }
      commitDiagramModel(diagram, addAttributeItemToClass(classIri, item));
    },
    [classIri, diagram]
  );
};
